<template>
  <div>
    <checkout :checkMethod="true" />
    <div class="row">
      <div class="d-flex flex-row justify-content-end">
        <form :action="config.BASE_URL+'/payments'" method="post">
          <input hidden type="hidden" name="ids" v-model="ids">
          <input hidden type="hidden" name="user_id" v-model="user_id">
          <input hidden type="hidden" name="phone" v-model="phone_number">
          <input hidden type="hidden" name="email" v-model="email">
          <button type="submit" class="btn btn-danger " @click="methodPayment()">پرداخت انلاین
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script setup>
import checkout from "@/agent/components/checkout/listsBasket.vue"
import {computed} from "vue";
import {useStore} from 'vuex'
import {$ref} from "vue/macros";
import config from "../../../../config/config.json"

const store = useStore();

const lists = computed(() => {
  return store.state.listCard
})
let status = $ref()
let ids = $ref([])
let user_id = $ref()
let phone_number = $ref();
let email = $ref();

function methodPayment() {
  let lists = store.state.listCard;
  for (let i = 0; i < lists.length; i++) {
    let parts = lists[i].ids.split("_");
    ids.push(parts[0]);
  }
  let result = JSON.parse(localStorage.getItem('users'));
  user_id = result.id;
  phone_number = result.phone_number;
  email = result.email;
}

methodPayment()
</script>
